import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveProductUrl from '../../../utils/urls/resolve-product-url';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon.tsx";
import Thumbnail from '../../thumbnail';

const PaydayLoanProducts = ({ active }) => {
  const { category, products } = useStaticQuery(graphql`
    query PaydayLoanProducts {
      category: mysqlTerms(cluster: {eq: "firms_1"}) {
        term_normalized
        path
      }

      products: allMysqlFirm(
        filter: {firmtypes: {elemMatch: {mysqlId: {glob: "*-1"}}}, form_visible: {eq: 1}}, 
        limit: 12
      ) {
        nodes {
          name
          specific_url
          prefix_url
          url
          mysqlImage {
            childImageSharp {
              gatsbyImageData(width: 55,  outputPixelDensities: [1, 2])
            }
          }
        }
      }
    }
  `);

  if (!products.nodes.length || !category) {
    return null;
  }

  return (<>
    <strong>Oferty chwilówek</strong>

    <div className={['top-navigation-products-square', b.mt2, b.pt1].join(' ')}>
      {products.nodes.map((product, i) => (
        <Link key={i} to={resolveProductUrl(product)}>
          {active && <div className="top-navigation-logo-wrapper">
            <Thumbnail image={product.mysqlImage} alt="" />
          </div>}

          <span>{product.name}</span>
        </Link>
      ))}
    </div>

    <Link className={[b.btn, "btn-light", "btn-cta", 'button-white', b.mt4].join(" ")} to={resolveUrl(category.path, category.term_normalized)}>
      {active && <Icon size={17} icon="Info" />}

      Informacje o chwilówkach
    </Link>
  </>);
};

export default PaydayLoanProducts;
